import React from 'react';

const getPlaybackUrlFromMovie = (record) => {
    if ( ! record  ) {
        return null;
    }
    if ( ! record.high_quality_file_id) {
        if ( record.public_url ) {
            return record.public_url;
        }
    } else {
        return null;
    }
    //https://hls-dvr-gv.filmon.com/bss06-la3.filmon.com/vod/_definst_/content_filmon/source/339/138361/462647/462647/seg-1-v1-a1.ts
    const streamServer = 'hls-dvr-gv.filmon.com';
    // return "https://hls-dvr-gv.filmon.com/bss06-la3.filmon.com/vod/_definst_/content_filmon/source/339/145426/483454/483454/playlist.m3u8";
    return `https://${streamServer}/${record.public_url}`;
};

export const MoviePreview =  ({record}) => {
    const src = getPlaybackUrlFromMovie(record);
    const source = {
        src
    };
    if ( /\.m3u8$/.test(src)) {
        source.type = 'application/x-mpegURL';
    }

    return src ? (
        <VideoPlayer
            controls={true}
            stream={source}
            />
    ) : <div> No Source to playback </div>;
};


export class VideoPlayer extends React.Component {
    componentDidMount() {
        // instantiate Video.js
        this.player = window.videojs(
            this.videoNode,
            {
                fluid: true,
                ...this.props
            }
        ).ready(() => {
            console.log("Player ready!", this.props.stream);
            this.player.src(this.props.stream);
        });
    }

    // destroy player on unmount
    componentWillUnmount() {
        if (this.player) {
            this.player.dispose()
        }
    }

    // wrap the player in a div with a `data-vjs-player` attribute
    // so videojs won't create additional wrapper in the DOM
    // see https://github.com/videojs/video.js/pull/3856
    render() {
        return (
            <div style={{width: "100%"}}>
                <div data-vjs-player>
                    <video
                        ref={ node => this.videoNode = node }
                        className="video-js vjs-big-play-centered vjs-16-9">
                    </video>
                </div>
            </div>
        )
    }
}
